import { getImageDimensions } from 'lib/utils'
import { useEffect, useState } from 'react'

type Dimensions = {
  width: number
  height: number
  ratio: number
}

export const useGetImageDimensions = (src: string) => {
  const [dimensions, setDimensions] = useState<Dimensions | null>(null)

  const onMount = async (url: string) => {
    const { width, height } = await getImageDimensions(url)

    setDimensions({
      width,
      height,
      ratio: width && height ? width / height : 1,
    })
  }
  useEffect(() => {
    onMount(src)
  }, [src])

  return dimensions
}
